import { render, staticRenderFns } from "./RiskDebtShowBlock.vue?vue&type=template&id=3dc24bb1&scoped=true"
import script from "./RiskDebtShowBlock.vue?vue&type=script&lang=js"
export * from "./RiskDebtShowBlock.vue?vue&type=script&lang=js"
import style0 from "./RiskDebtShowBlock.vue?vue&type=style&index=0&id=3dc24bb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc24bb1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VRow,VSkeletonLoader,VSpacer,VToolbar,VToolbarTitle})
